import Vue from 'vue';
import {Wrapper} from '@vue/test-utils';
import {getBaseURL, multiNil, nil} from '@/common';

declare module 'vue/types/vue' {
    interface Vue {
        $FeathersVuex: any;
        $bus: any;
        isXS: (qd: boolean | null) => boolean;
        isSM: (qd: boolean | null) => boolean;
        isMD: (qd: boolean | null) => boolean;
        isLG: (qd: boolean | null) => boolean;
        isXL: (qd: boolean | null) => boolean;
        onResize: (func: () => void) => void;
        $vuetify: {
            breakpoint: {
                name: string,
            },
        };

    }
}
declare module '@vue/test-utils' {
    interface MyWrapper<V extends Vue | null> extends Wrapper<V> {
        $FeathersVuex: any;
        $bus: any;
        isXS: (qd: boolean | null) => boolean;
        isSM: (qd: boolean | null) => boolean;
        isMD: (qd: boolean | null) => boolean;
        isLG: (qd: boolean | null) => boolean;
        isXL: (qd: boolean | null) => boolean;
        onResize: (func: () => void) => void;
        $vuetify: {
            breakpoint: {
                name: string,
            },
        };

    }
}

function resolveQueryDirection(query: boolean | null, onExact: boolean, onLess: boolean, onMore: boolean) {
    return nil(query) ? onExact
        : query ? onMore
            : onLess;
}
export default (VueInstance) => {
    VueInstance.prototype.$bus = new Vue();
    VueInstance.prototype.BASE_URL = getBaseURL();
    VueInstance.prototype.nil = (obj: any | null | undefined, falsyCounts: boolean = false) => {
        return nil(obj, falsyCounts);
    };
    VueInstance.prototype.multiNil = (obj: any | null | undefined, path: string, falsyCounts: boolean = false) => {
        return multiNil(obj, path, falsyCounts);
    };

    VueInstance.prototype.onResize = (func: () => void) => {
        window.addEventListener('resize', () => {
            func();
        });
    };
    VueInstance.prototype.isXS = function(queryDirection = null) {
        return resolveQueryDirection(queryDirection, this.$vuetify.breakpoint.xs, true, false);
    };
    VueInstance.prototype.isSM = function(queryDirection) {
        return resolveQueryDirection(queryDirection, this.$vuetify.breakpoint.sm, this.$vuetify.breakpoint.smAndDown, this.$vuetify.breakpoint.smAndUp);
    };
    VueInstance.prototype.isMD = function(queryDirection) {
        return resolveQueryDirection(queryDirection, this.$vuetify.breakpoint.md, this.$vuetify.breakpoint.mdAndDown, this.$vuetify.breakpoint.mdAndUp);
    };
    VueInstance.prototype.isLG = function(queryDirection) {
        return resolveQueryDirection(queryDirection, this.$vuetify.breakpoint.lg, this.$vuetify.breakpoint.lgAndDown, this.$vuetify.breakpoint.lgAndUp);
    };
    VueInstance.prototype.isXL = function(queryDirection = null) {
        return resolveQueryDirection(queryDirection, this.$vuetify.breakpoint.xl, false, true);
    };
};
